import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // Declared before the '' layout: that route matches as a prefix and passes the
  // rest into a lazily loaded module, which never gives the URL back.
  {
    path: 'pay',
    loadChildren: () => import('./pages/pay-link/pay-link.module').then(m => m.PayLinkModule)
  },
  {
    path: '',
    loadChildren: () => import('./modules/shared/sharedLayout/shared-layout.module').then(m => m.SharedLayoutModule)
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'pricing',
    loadChildren: () => import('./pages/pricing/pricing.module').then(m => m.PricingModule)
  },
  {
    path: 'unsubscribe',
    loadChildren: () => import('./pages/unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule)
  },
  {
    path: '**',
    loadChildren: () => import('./pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking', anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
